export const opacities = {
  opacity50: '0.5',
};
